<template>
  <div class="doc-page-main">
    <div class="left-container" :class="[ closeLeftTab ? !narrowWindow ? 'left-tab-close' : 'left-tab-close-up-down' : '' ]">
      <div class="arrow-button">
        <img :style="{ transform: `${closeLeftTab && !narrowWindow ? `scaleX(-1)` : (!closeLeftTab && !narrowWindow ? `scaleX(1)` : (closeLeftTab && narrowWindow ? `rotate(90deg) scaleX(-1)` : `rotate(90deg) scaleX(1)`))}` }"
          @click="closeLeftTab = !closeLeftTab" src="https://img.icons8.com/material-rounded/96/000000/double-left.png" />
      </div>
      <div class="refresh-icon" v-if="closeLeftTab">
        <Tooltip style="cursor: pointer" icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" 
          :iconSize="30" @click.native="refreshClicked">
          <div slot="tooltipText">
            <div>Document Type: {{refreshDocType ? refreshDocType : 'ALL'}}</div>
            <div>Limit: {{selectedTop ? selectedTop['top'] : '0'}}</div>
          </div>
        </Tooltip>
      </div>
      <div class="quick-approve-icon" v-if="closeLeftTab">
        <Tooltip style="cursor: pointer" icon="https://dsmapi.logistics.systems/dsm6gicons/QuickApproveIcon.png" 
          :iconSize="30"  @click.native="quickApprovedClicked">
          <div slot="tooltipText">
            <div>Selected Document: {{checkedCount}}</div>
          </div>
        </Tooltip>
      </div>
      <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">
        <Dropdown class="left-container-content-field" placeholder="Document Type" :items="docType" itemKey="Code" :selectedObject.sync="selectedDocType" />
        <button class="refresh-button" @click="refreshClicked">Refresh</button>
        <Dropdown placeholder="Limit" :items="topList" itemKey="top" :selectedObject.sync="selectedTop" />
        <Dropdown placeholder="Status" :items="statusType" itemKey="Status" :selectedObject.sync="selectedStatus" />
        <Dropdown placeholder="Issued To" :items="issuedTo" itemKey="Issued To" :selectedObject.sync="selectedIssuedTo" />
        <Dropdown placeholder="Payment Type" :items="paymentType" itemKey="Payment Type" :selectedObject.sync="selectedPaymentType" />
        <Input placeholder="Created By" :inputValue.sync="createdby" />
        <Filters class="charges-filter" title="Charges Code" :tableData="chargesCode" itemKey="Charge Code" itemDesc="Description" :selectedObject.sync="selectedChargesCode" @click.native="showInfoPopup = false"/>
        <div class="amount-container">
          <button style="width: 20%" @click="amountOperationIndex++">{{ amountOperation }}</button>
          <Input style="width: 80%" placeholder="Amount" :inputValue.sync="amount" />
        </div>
        <button class="reset-filter-button" @click="resetFilterClick">Reset Filters</button>
        <button class="quick-approve-button" @click="quickApprovedClicked">Quick Approve Documents ({{checkedCount}})</button>
        <button class="approve-button" @click="approveButtonClick">Approve Documents ({{checkedCount}})</button>
        <button class="reject-button" @click="rejectButtonClick">Reject Documents ({{checkedCount}})</button>
        <button class="generate-button" @click="generateButtonClick">Generate List</button>
      </div>
    </div>
    <div class="right-container" :style="{ width: fixWidth }">
      <div class="top-container" :class="[ closeFilterMesgTab ? 'right-filter-msg-close' : '' ]">
        <div class="filters-text" :style="{ display: `${closeFilterMesgTab ? `none` : ``}` }" >
          <div class="inline-text">
            <div class="caption">Last Refreshed</div>
            <div>:</div>
            <div>{{ lastRefreshed }}</div>
          </div>
          <div class="inline-text">
            <div class="caption">Document Type</div>
            <div>:</div>
            <div>{{ refreshDocType ? refreshDocType : 'ALL' }}</div>
          </div>
          <div class="inline-text">
            <div class="caption">Document Status</div>
            <div>:</div>
            <div>{{ selectedStatus ? selectedStatus['Status'] : 'ALL' }}</div>
          </div>
          <div class="inline-text">
            <div class="caption">Issued To</div>
            <div>:</div>
            <div>{{ selectedIssuedTo ? selectedIssuedTo['Issued To'] : 'ALL' }}</div>
          </div>
          <div class="inline-text">
            <div class="caption">Payment Type</div>
            <div>:</div>
            <div>{{ selectedPaymentType ? selectedPaymentType['Payment Type'] : 'ALL' }}</div>
          </div>
          <div class="inline-text">
            <div class="caption">Created By</div>
            <div>:</div>
            <div>{{createdby}}</div>
          </div>
          <div class="inline-text">
            <div class="caption">Amount</div>
            <div>:</div>
            <div>{{amount ? amount : 0}}</div>
          </div>
        </div>        
        <div class="message-box" :style="{ display: `${closeFilterMesgTab ? `none` : ``}` }" ref="msgbox">{{approveResultMessage}}</div>
         <div class="arrow-button">
          <img :style="{ transform: `${closeFilterMesgTab ? `rotate(-90deg)` : `rotate(-90deg) scaleX(-1)` }`}"
            @click="closeFilterMesgTab = !closeFilterMesgTab" src="https://img.icons8.com/material-rounded/96/000000/double-left.png" />
        </div>
      </div>

      <div class="bottom-container" :style="{ height: fixHeight }">
        <div v-for="(b, bi) in buckets" :key="bi" class="bucket" :style="{ width: `${100 / buckets.length}%` }">
          <div class="header" :style="{ backgroundColor: b['Colour'] }">
            <div v-if="bi < buckets.length - 1" class="bucketTotal">Bucket Total : {{b['total'] ? b['total'] : '0'}}</div>
            <!-- <button @click="selectVisibleDocOnly"></button> -->
            <Tooltip v-if="bi < buckets.length - 1" class="tooltip-button" icon="https://dsmlib.logistics.systems/Icons/icons8-approve.png" :tooltipText="bucketsSelectVisibleTooltip[bi]['text']" position="top"
              @click.native="selectVisibleDocOnly(bi)" />
            <div class="title">
              
              <CheckBox v-if="bi < buckets.length - 1" class="checkbox-bucket" :title="b['Bucket']" :isChecked.sync="b['bucketChecked']" @checkBoxClicked="bucketChecked(bi)" />
              <div v-else style="text-align:center">{{ b['Bucket'] }}</div>
            </div>
            <!-- <div class="title">{{ b['Bucket'] }}</div> -->
            <div v-if="bi < buckets.length - 1" class="count">Total {{b['FilteredCount'] ? b['FilteredCount'] + '/' : ( b['FilteredCount'] == 0 ? '0/' : b['Documents'].length + '/') }}{{ b['Documents'] ? b['Documents'].length : 0 }} Document(s)</div>
            <div v-else class="count">Total {{ b['Documents'] ? b['Documents'].length : 0 }} Document(s)</div>
          </div>
          <div class="content" @scroll="bucketScrolling(bi)">
            <div class="content-item" v-for="(d, di) in b['Documents']" :key="di" :style="{ display: d['show'] ? 'block' : 'none' }"
              :docIndex="di" :bucketIndex="bi">
              <div class="content-row">
                <CheckBox v-if="bi < buckets.length - 1" class="doc-no" :title="d['Document No'] ? d['Document No'].trim() : ''" :isChecked.sync="d['checked']" :isDisabled="d['APStatus'] == 'R' || d['Assigned'] == '0'" @checkBoxClicked="documentChecked(bi)" /> 
                <div v-else class="doc-no">{{ d['Document No'] ? d['Document No'].trim() : '' }}</div>
                <div class="pay-button">Payment</div>
              </div>
              <div class="content-row">
                <div>Date: {{ d['Date Issued'] ? new Date(d['Date Issued']).formatString('yyyy-MM-dd') : '' }}</div>
                <div class="amount">{{ d['Currency'] ? d['Currency'].trim() : '' }} {{ d['Total Amount'] ? parseFloat(d['Total Amount']).toFixed(2) : '' }}</div>
              </div>
              <div class="long-text">
                <div :title="d['Issued To'] ? d['Issued To'].trim() : ''" >Issued To: {{ d['Issued To'] ? d['Issued To'].trim() : '' }}</div>
                <div :title="d['shipper/consignee'] ? d['shipper/consignee'].trim() : ''">Shpr/Csgn: {{ d['shipper/consignee'] ? d['shipper/consignee'].trim() : '' }}</div>
              </div>
              <div class="content-row">
                <div>Requested by: {{ d['User ID'] ? d['User ID'] : '' }}</div>
                <div class="icon-button">
                  <img style="cursor: auto;" v-if="d['APStatus'] == 'R'" src="https://dsmlib.logistics.systems/Icons/RejectedIconDA.png" :title="`${d['APRemark']}`" alt="">
                  <img style="cursor: auto;" v-if="d['AssignedUser'] != 'ALL'" src="https://dsmlib.logistics.systems/Icons/AssignedRequired.png" alt="" :title="`Required ${d['AssignedUser']} Approval`">
                  <img v-if="bi < buckets.length - 1" src="https://dsmlib.logistics.systems/Icons/TooltipInfo.png" title="Additional Info" @click="infoClicked($event, d)" alt="">
                  <img v-if="bi == 3" @click="cancelApproveDocument(d)" src="https://dsmlib.logistics.systems/Icons/Document_Cancel.png" title="Cancel Document" alt="">
                  <img v-if="d['Attachment'] > 0" src="https://dsmlib.logistics.systems/Icons/Attachment.png" title="View Attachment" @click="showAttachment($event, d)" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-popup" v-if="showInfoPopup" :style="infoPopupStyle">
      <div class="info-header">
        <div>{{ infoPopupDetails['Document No'] }}</div>
        <!-- <div @click="showInfoPopupDetailsMore = !showInfoPopupDetailsMore">{{showInfoPopupDetailsMore ? 'Less←' : 'More→'}}</div> -->
        <div style="user-select: none;" @click="infoMoreClicked($event)">{{showInfoPopupDetailsMore ? 'Less←' : 'More→'}}</div>
        <div @click="showInfoPopup = false">⊗</div>
      </div>
      <div class="info-content">
        <!-- <div class="info-content-row" v-for="(d, i) in infoPopupDetails['AdditionalDetails']" :key="i" :style="{ display: d['visible'] ? '' : 'none' }"> -->
        <table class="info-content-table">
          <tr class="info-content-header">
            <th>#</th>
            <th>Item Desc</th>
            <th>Cur</th>
            <th><div class="tableTooltip">Buying<span class="tableTooltipText">{{infoPopupDetails['TotalOffsetAmt']}}</span></div></th>
            <th v-if="showInfoPopupDetailsMore"><div class="tableTooltip">Mark Up<span class="tableTooltipText">{{infoPopupDetails['TotalAdjustAmt']}}</span></div></th>
            <th v-if="showInfoPopupDetailsMore"><div class="tableTooltip">Selling<span class="tableTooltipText">{{infoPopupDetails['TotalNetAmt']}}</span></div></th>
            <th>Ref</th>
          </tr>
          <tr class="info-content-row" v-for="(d, i) in infoPopupDetails['AdditionalDetails']" :key="i">
            <td>{{ d['SeqNo'] ? d['SeqNo'].trim() : '' }}</td>
            <td>{{ d['ChargesCode'] ? `(${d['ChargesCode']}) ${d['ItemDesc']}` : d['ItemDesc'] }}</td>
            <td>{{ d['Currency'] ? d['Currency'].trim() : '' }}</td>
            <td>{{ d['OffsetAmt'] ? parseFloat(d['OffsetAmt']).toFixed(2) : '-' }}</td>
            <td v-if="showInfoPopupDetailsMore">{{ d['AdjustAmt'] ? parseFloat(d['AdjustAmt']).toFixed(2) : '-' }}</td>
            <td v-if="showInfoPopupDetailsMore">{{ d['NetAmt'] ? parseFloat(d['NetAmt']).toFixed(2) : '-' }}</td>
            <td>{{ d['RefNo'] ? d['RefNo'].trim() : ''}}</td>
          </tr>
        </table>
        <!-- <div class="info-content-header">
          <div>#</div>
          <div>Item Desc</div>
          <div>Cur</div>
          <div style="text-align: right;">Amt</div>
          <div style="text-align: right;" v-if="showInfoPopupDetailsMore" >Adj</div>
          <div style="text-align: right;" v-if="showInfoPopupDetailsMore">Net</div>
          <div>Ref</div>
        </div>
        <div class="info-content-row" v-for="(d, i) in infoPopupDetails['AdditionalDetails']" :key="i" >
          <div>{{ d['SeqNo'] ? d['SeqNo'].trim() : '' }}</div>
          <div>{{ d['ItemDesc'] ? d['ItemDesc'].trim() : '' }}</div>
          <div>{{ d['Currency'] ? d['Currency'].trim() : '' }}</div>
          <div style="text-align: right;">{{ d['OffsetAmt'] ? parseFloat(d['OffsetAmt']).toFixed(2) : '-' }}</div>
          <div style="text-align: right;" v-if="showInfoPopupDetailsMore">{{ d['AdjustAmt'] ? parseFloat(d['AdjustAmt']).toFixed(2) : '-' }}</div>
          <div style="text-align: right;" v-if="showInfoPopupDetailsMore">{{ d['NetAmt'] ? parseFloat(d['NetAmt']).toFixed(2) : '-' }}</div>
          <div>{{ d['RefNo'] ? d['RefNo'].trim() : ''}}</div>
        </div> -->
      </div>
    </div>

    <div class="attchWin-main" v-if="showAttachmentPopup">
      <button class="attchWin-close" @click="closeshowAttachmentPopup()" >X</button>
      <div class="attchWin-display" v-if="this.attachmentList.length > 0">
        <div class="left">
          <div v-if="this.attachmentList.length > 1" class = "leftButton">
            <button class="navButton-left" @click="navAtt('prev')">&lt;</button>
          </div>
            <div class="attchWin-attachment">
              <iframe class="att-iframe" v-show="hidepdf" v-if="this.attToView['AttImageType'].trim() === '.ogg' || this.attToView['AttImageType'].trim() ==='.pdf'" :src="this.attToView['AttImageType'].trim() === '.pdf' ? `${this.attToView['AttImage']}#view=FitH` : this.attToView['AttImage']" />
              <img style="width:20%;" v-show="!hidepdf" class="pdf-dwd" v-if="this.attToView['AttImageType'].trim() === '.ogg' || this.attToView['AttImageType'].trim() ==='.pdf'"  src="https://dsmapi.logistics.systems/dsm6gicons/icons8-attachment-file.png" @click="downloadpop()"/>
              <img v-else-if="this.attToView['AttImageType'] === '.jpg' || this.attToView['AttImageType'] === 'image/Jpeg' || this.attToView['AttImageType'] === 'image/png' || this.attToView['AttImageType'] === '.jpeg' || this.attToView['AttImageType'] === 'image/jpeg' || this.attToView['AttImageType'] === '.png' || this.attToView['AttImageType'] === '.gif'|| this.attToView['AttImageType'] === '.bmp' || this.attToView['AttImageType'] ==='n/a'"   :src="this.attToView['AttImage']" style="cursor:context-menu" @click="downloadpop()"/>
              <img style="width:30%;" v-else-if="this.attToView['AttImageType'] === '.docx' || this.attToView['AttImageType'] === '.doc'" src="https://i.ibb.co/PtPtyLZ /word.png"  @click="downloadpop()"/>
              <img style="width:30%;" v-else-if="this.attToView['AttImageType'] === '.pptx'" src="https://i.ibb.co/n3904Sm/ppt.png" @click="downloadpop()"/>
              <img style="width:30%;" v-else-if="this.attToView['AttImageType'] === '.msg' || this.attToView['AttImageType'] === '.eml'" src="https://i.ibb.co/sjQCXt2/mail.png" @click="downloadpop()"/>
              <img style="width:30%;" v-else-if="this.attToView['AttImageType'] === '.xlsx'" src="https://i.ibb.co/JFp0hrh/excel.png"  @click="downloadpop()"/>
              <img style="width:20%;" v-else src="https://dsmapi.logistics.systems/dsm6gicons/icons8-attachment-file.png" @click="downloadpop()">
            </div>
            <div v-if="this.attachmentList.length > 1" class = "rightButton">
              <button class="navButton-right" @click="navAtt('next')" >></button>
            </div>
        </div>
        <div class="right">
          <div class="count"><b>{{this.attToView['#']}}</b> / {{this.attachmentList.length}} Attachments</div>
          <div class="attchWin-info" >
            <img style="width: 30px; height: 30px; position: absolute; right: 0; top: 20px;" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png" title="Click on image to download files (Excl. PDF)">
            <table id="infoHeader">
              <tr>
                <th> Payment No </th>
                <td >:{{this.attToView['Job No']}}</td>
              </tr>
              <tr>
                <th> Remarks </th>
                <td>:{{this.attToView['Remarks'] ? this.attToView['Remarks'] : '-'}} </td>
              </tr>
            </table>  
            <table id="tableContent">
              <tr>
                <th> # </th>
                <td>{{this.attToView['#'] ? this.attToView['#'] : '-'}} </td>
              </tr>
              <tr>
                <th> Reference No </th>
                <td>{{this.attToView['Reference No'] ? this.attToView['Reference No']: '-'}} </td>
              </tr>
              <tr>
                <th> Category </th>
                <td>{{this.attToView['Category'] ? this.attToView['Category'] : '-'}} </td>
              </tr>
              <tr>
                <th> Type </th>
                <td>{{this.attToView['Type'] ? this.attToView['Type'] : '-'}} </td>
              </tr>
              <tr>
                <th> Received Time </th>
                <td>{{this.attToView['Received DateTime']? this.attToView['Received DateTime']: '-'}} </td>
              </tr>
              <tr>
                <th> Document Date </th>
                <td>{{this.attToView['Document Date'] ? this.attToView['Document Date'] : '-'}} </td>
              </tr>
              <tr>
                <th> Uploaded By </th>                
                <td>{{this.attToView['UserID'] ? this.attToView['UserID'] : '-'}} </td>
              </tr>
              <tr>
                <th> Job No </th>
                <td>{{this.attToView['JobNo'] ? this.attToView['JobNo'] : '-'}} </td>
              </tr>
              <tr>
                <th> Shipper / Consignee</th>
                <td>{{this.attToView['shipper/consignee'] ? this.attToView['shipper/consignee'] : '-'}} </td>
              </tr>
              <tr>
                <th> Payee/Issued To </th>                
                <td>{{this.attToView['Issued To'] ? this.attToView['Issued To'] : '-'}} </td>
              </tr>
              <tr>
                <th> BL Number </th>                
                <td>{{this.attToView['BL No'] ? this.attToView['BL No'].trim() : '-'}} </td>
              </tr>
              <tr>
                <th> Container No </th>                
                <td><div v-for="c in containers" :key="c" style="padding:0;">{{c}}</div> </td>
              </tr>
              <tr>
                <th> Total Amount </th>                
                <td>{{this.attToView['Currency'].trim()}} {{this.attToView['Total Amount'] ? parseFloat(this.attToView['Total Amount']).toFixed(2) : '-'}} </td>
              </tr>
            </table>
            <div>
              Charges Code for {{this.attToView['Job No']}}
            </div>
            <div class="attachmentAddInfoMain">
              <div class="addInfoRow" v-for="(a, i) in this.attAdditionalDetails" :key="'addinfo' + i">
                <div style="width: 20px; min-width: 20px;">{{a['SeqNo']}}</div>
                <div style="width: 120px; min-width: 120px;">{{a['ItemDesc'].trim()}}</div>
                <!-- <div style="width: 100px; min-width: 100px; display: flex; align-items: center; justify-content: space-between;"> -->
                  <div style="width: 100px; min-width: 100px; display: flex; align-items: center; justify-content: space-evenly;">
                  <span>{{a['Currency'].trim()}}</span>
                  <span style="">{{parseFloat(a['FOffsetAmt']).toFixed(2)}}</span>
                </div>
                <div style="flex: 1;">{{a['Remark'] ? a['Remark'] : ''}}</div>
                <div style="width: 70px; min-width: 70px;"> {{a['RefNo'] ? a['RefNo'] : '-'}} </div>
              </div>
            </div>
            <!-- <button @click="appPopup(attachmentSel, attachmentAction);">{{attachmentAction == 'approve' ? ('Approve ' + attachmentSel['Document Type']) : ('Unapprove ' + attachmentSel['Document Type'])}}</button> -->
          </div>
        </div>
      </div>
      <div v-else class="attchWin-display" >
        <div style="margin:0 auto;">No Attachments Found</div>
      </div>
    </div>

    <PopupEntry v-if="showApprovePopup" :show.sync="showApprovePopup" :title="`${popupEntryRequest} Documents`" @save="approveClick" :errorMessages.sync="Emessages" :successMessages="successMessages"
      :viewMode="viewMode" updatedBy='' createdBy='' ref="approvalPopup" @cancelClick="cancelClick" style="overflow-y: scroll;">
      <div class="popup-content" id="popup-content" style="height:100%; overflow: auto;">
        <div class='pv-details' v-for="(i,index) in this.selectedCheckedDocument" :key="index" style="margin-bottom: 5px; border-bottom-style: ridge;">
          <p>{{index+1}}) {{i['Document No']? i['Document No'] : i['TxnID'] }}</p>
          <Input :isDisabled="popupEntryRequest == 'Reject'" textType="file" :multiFile="true" @fileChanged="documentSelected($event, index)" :placeholder="'Select Documents for '+i['Document No']" />
          <RemarksBox :isDisabled="popupEntryRequest =='Reject'" class="documentRemarksBox" title="Documents Remarks" maxLength=200 :text.sync="selectedCheckedDocument[index]['documentremarks']" style="width: 100%;height: 100px;"/>
          <RemarksBox class="approveRemarksBox" :title="`${popupEntryRequest} Remarks`" maxLength=200 :text.sync="selectedCheckedDocument[index]['approveremarks']" :isRequired="popupEntryRequest == 'Reject'" style="width: 100%;height: 100px;"/>
          <tr>
            <th>{{i['Document Type'] =='Payment'? 'Payment No' : 'Transaction No'}}</th>
            <td>:{{i['Document No']? i['Document No'] : i['TxnID'] }}</td>
          </tr>
          <tr>
            <th>Issued To</th>
            <td>:{{i['Issued To']}}</td>
          </tr>
          <tr>
            <th>Total Amount</th> 
            <td>: {{i['Currency']}} {{parseFloat(i['Total Amount']).toFixed(2)}}</td>
          </tr>
          <tr>
            <th>Issued Date</th>
            <td>: {{i['Date Issued']? i['Date Issued']: ''}}</td>
            <!-- <td>: {{i['Date Issued']? i['Date Issued'].split("T")[0].replaceAll('-', '/'): ''}}</td>
            -->
          </tr>
          <tr>
            <th>Requested by</th>
            <td>: {{i['User ID']}}</td>
          </tr>
          <tr>
            <th>Remarks</th>
            <td>: {{i['Remark']? i['Remark'] : '-'}}</td>
          </tr>
        </div>
      </div>
    </PopupEntry>

    <PopupV2 :show="showGenerateListPopup" @buttonClicked="generateListButtonClick" title="Generate Approved PV Pre-authorize List" :buttons="buttonsArray" height="80%" width="45%">
      <div class="generateList-main">
        <div class="generateList-filter">
          <!-- <Dropdown placeholder="Bank" isRequired="true" :items="bankCode" itemKey="BankCodeBankName" :selectedObject.sync="selectedBankCode" @selected="getGenerateListTableData(...arguments, 'GETALLFILENO')" /> -->
          <Dropdown placeholder="Bank" isRequired="true" :items="bankCode" itemKey="BankCodeBankName" :selectedObject.sync="selectedBankCode" />
          <Dropdown placeholder="File" :items="fileno" itemKey="FileNo" :selectedObject.sync="selectedFileNo" />
        </div>
        <div class="generateList-table">
          <TableBox :tableData="fileNoTableData" :title="generateListTableTitle" maxSelection=0 :downloadName="generateListTableTitle" :hideColumns="['FileNo', 'Document Link']" :dataType="{ 'RM': 'number', 'PV Date': 'date' }" :excelColumns="excelColumns" />
        </div>
      </div>
    </PopupV2>

    <Loader :isVisible.sync="loading" :loadingText="loadText" />

    <div class="designerv2-popup" v-if="showDesignerV2">
      <DesignerV2 :show.sync="showDesignerV2" :viewMode="true" reportFolder="ROTForm" :reportFile="designerV2ReportFile"
        :reportData="designerV2Data" />
    </div>
  </div>
</template>

<script>
// import { threadId } from 'worker_threads';
import TableBox from '../../../components/v2testComponent/TableBox.vue';
/* eslint-disable */
export default {
  components: {
    TableBox
  },
  data: function() {
    return {
      loading: false,
      loadText: 'Loading',

      getDocApprovalPromises: [],

      userid: '',
      lastRefreshed: '',

      menuOpen: true,

      closeLeftTab: false,
      narrowWindow: false,
      closeFilterMesgTab: false,

      docType: [ { "#": 1, "Type": "All", "Code": "ALL" },{ "#": 2, "Type": "Payment", "Code": "Payment" }, { "#": 3, "Type": "Cheque", "Code": "Cheque" }  ],
      topList: [ {'top': '50'},{'top': '100'},{'top': '500'},{'top': 'ALL'} ],
      statusType: [ {"#": 1, "Status": "All"}, {"#": 2, "Status": "Pending"}, {"#": 3, "Status": "Rejected"} ],
      selectedDocType: null,
      selectedTop: '',
      selectedStatus: null,
      refreshDocType: null,

      issuedTo: [],
      selectedIssuedTo: null,

      paymentType: [],
      selectedPaymentType: null,

      createdby: '',

      chargedescription: '',

      chargesCode: [],
      selectedChargesCode: [],

      amountOperationIndex: 0,
      amountOperations: [ '>=', '<=', '=' ],
      amount: '0',

      showInfoPopup: false,
      infoPopupStyle: {},
      infoPopupDetails: null,
      showInfoPopupDetailsMore: false,

      checkedCount: 0,
      selectedCheckedDocument: [],

      bucketsFilteredCount: 0,

      buckets: [],
      bucketsSelectVisibleTooltip: [],

      showApprovePopup: false,

      hidepdf: true,
      showAttachmentPopup: false,
      attachmentList: [],
      attToView: [],
      attAdditionalDetails: [],

      approveResultMessage: '',

      popupEntryRequest: '',
      Emessages: [],
      successMessages: [],

      showDesignerV2: false,
      designerV2Data: null,
      designerV2ReportFile: ['DocumentApprovalList.json'],

      //#region Generate List Popup
      showGenerateListPopup: false,
      buttonsArray: [
        { "text":"Generate New List" }, 
        { "text":"Print List" }, 
        { "text":"Cancel" }
      ],
      generateListTableTitle: '',

      bankCode: [],
      selectedBankCode: null,

      fileno: [],
      // file
      selectedFileNo: null,
      newFileNo: null,

      fileNoTableData: [],

      excelColumns: [
        { "key": "No.", "title": "No." },
        { "key": "Payee", "title": "Payee" },
        { "key": "PV No.", "title": "PV No." },
        { "key": "Doc Ref.", "title": "Doc Ref." },
        { "key": "ROC", "title": "RM" },
        { "key": "Bank Name(Acc No.)", "title": "Bank Name(Acc No.)" },
        { "key": "PV Date", "title": "PV Date" },
        { "key": "Document Link", "title": "Document Link" },
      ],
      //#endregion
    }
  },
  props: {
  },
  computed: {
    amountOperation: function() {
      if (this.amountOperationIndex > 2) {
        this.amountOperationIndex = 0;
      }
      return this.amountOperations[this.amountOperationIndex];
    },
    fixWidth: function() {
      let width = "0px";
      if (this.closeLeftTab && !this.narrowWindow) {
        width = "40px";
      } else if (this.closeLeftTab && this.narrowWindow) {
        width = "0px";
      } else if (!this.closeLeftTab && !this.narrowWindow) {
        width = "250px";
      } else if (!this.closeLeftTab && this.narrowWindow) {
        width = "0px";
      }
      return `calc(100% - ${width})`;
    }, 
    fixHeight: function() {
      let height = "0px";
      if (this.closeFilterMesgTab && !this.narrowWindow) {
        height = "35px";
      } else if (!this.closeFilterMesgTab && !this.narrowWindow) {
        height = "140px";
      }
      return `calc(100% - ${height})`;
    }
  },
  methods: {
    refreshClicked: async function() {
      await this.callAPI();
      this.filterData();
      this.documentCheckedCount();
    },

    resetFilterClick: function() { 
      this.selectedIssuedTo = null;
      this.selectedPaymentType = null;
      this.createdby = '';
      this.selectedChargesCode = [];
      this.amount = '';
    },

    callAPI: async function() {
      this.loading = true;
      this.loadText = "Getting Details";

      this.getDocApprovalPromises = [];

      for (let b of this.buckets) {
        b['bucketChecked'] = false;

        var postData = {
          // "tablename": this.selectedDocuments['Code'],
          'tablename': this.selectedDocType['Code'],
          // 'authorized': 'C',
          'authorized': b['Bucket'].split(' ')[0] == 'Pending' ? 'U' : 'A',
          'actionflag': '',
          'paymentno': '',
          'txnid': '',
          'startdate': '',
          'enddate': '',
          'usercreate': '',
          // 'bucket': this.bucketDetails[i]['Bucket'],
          'bucket': b['Bucket'],
          'startusercreate': '',
          'endusercreate': '',
          'docatt': '',
          'attfile': '',
          'filetype': '',
          'remarks': '',
          'top': this.selectedTop ? this.selectedTop['top'] : ''
        }
        
        this.getDocApprovalPromises.push(
          this.$apiCallV2('/DocumentApproval/getDoc', postData).then((details) => {
            let docs = [];
            if (details['DocApproval']) {
              docs = details['DocApproval']['DocList'];
              b['total'] = details['DocApproval']['total'];
              docs.forEach(d => d['show'] = true);
              docs.forEach(d => d['checked'] = false);
            }

            if (docs) {
              docs.forEach(a => {
                if (a['AdditionalDetails']) {
                  if (a['AdditionalDetails'].length > 0) {
                    a['TotalOffsetAmt'] = "0";
                    a['TotalAdjustAmt'] = "0";
                    a['TotalNetAmt'] = "0";
                    a['AdditionalDetails'].forEach(b => {
                      a['TotalOffsetAmt'] = (+a['TotalOffsetAmt'] + (b['OffsetAmt'] ? +b['OffsetAmt'] : +"0.00")).toFixed(2);
                      a['TotalAdjustAmt'] = (+a['TotalAdjustAmt'] + (b['AdjustAmt'] ? +b['AdjustAmt'] : +"0.00")).toFixed(2);
                      a['TotalNetAmt'] = (+a['TotalNetAmt'] + (b['NetAmt'] ? +b['NetAmt'] : +"0.00")).toFixed(2);
                    })
                  }
                }
              })
            }

            this.$set(b, 'Documents', docs);
          })
        )
      }

      await Promise.allSettled(this.getDocApprovalPromises);
      
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm:ss');

      this.refreshDocType = this.selectedDocType['Code'];

      this.loading = false;
    },
    
    quickApprovedClicked: async function() {
      this.loading = true;
      let Request = this.popupEntryRequest == 'Reject' ? 'Rejected' : 'Approved';
      this.loadText = this.popupEntryRequest == 'Reject' ? 'Rejecting Documents' : 'Approving Documents';
      let allChecked = [];
      let count = 0;
      if (this.selectedCheckedDocument.length != 0) {
        for (let b of this.selectedCheckedDocument) {
          await this.approveDocument(b, Request);
          this.loadText = `${Request} Documents ${++count} of ${this.selectedCheckedDocument.length}`;
        }

        await this.refreshClicked();
      }
      else {
        this.approveResultMessage = this.approveResultMessage + 'Please select a document before making an approval.\n';
      }
      // this.buckets.data.forEach(b => {
      //   allChecked = allChecked.concat(b['Documents'].filter(d => d['checked']));
      // });
      // allChecked.forEach((a, ai) => {
      //   console.log(a);
      //   this.approveDocument(a);
      // });
      this.loading = false;
    },

    approveDocument: async function(val, Req) {
      console.log(Req);
      try {
        var dataToPost = {
          "tablename": val['Document Type'],
            "authorized": Req ? (Req == 'Rejected' ? 'R' : 'A') : "A",
            "actionflag":"E",
            "paymentno":val['Document No'].trim(),
            "txnid":"",
            "startdate":"",
            "enddate":"",
            "bucket": "",
            "startusercreate":"",
            "endusercreate":"",
            "remarks":val['approveremarks'] ? val['approveremarks'] : '',
            "documents":val['documents'] ? [{
              "docno":"",
              "doc":"ATT",
              "docremarks":"",
              "remarks":val['documentremarks'] ? val['documentremarks'] : '',
              "docaction":"N",
              "attachment":val['documents'] ? val['documents'] : null
            }] : []
        };
        console.log(dataToPost);
        var postApproval = await this.$apiCallV2('/DocumentApproval/approveDoc', dataToPost);
        console.log(postApproval);
      } catch (e) {
        console.log(e);
      }
      
      if (postApproval[0].Results == "0") {
        this.approveResultMessage = this.approveResultMessage + new Date().formatString('yyyy-MM-dd HH:mm:ss') + '| ' + val['Document Type'] + ' ' + val['Document No'].trim() + ' ' + Req.trim() + '.\n';
      } else {
        this.approveResultMessage = this.approveResultMessage + new Date().formatString('yyyy-MM-dd HH:mm:ss') + '| ' + val['Document Type'] + ' ' + val['Document No'].trim() + ' ' + Req.trim() + ' failed. ' + postApproval[0].ErrMsg + '.\n';
      }
    },

    cancelApproveDocument: async function(val) {
      try {
        var dataToPost = {
          "tablename": val['Document Type'],
            "authorized":"U",
            "actionflag":"E",
            "paymentno":val['Document No'].trim(),
            "txnid":"",
            "startdate":"",
            "enddate":"",
            "bucket": "",
            "startusercreate":"",
            "endusercreate":""
        }

        var postUnapprove = await this.$apiCallV2('/DocumentApproval/approveDoc', dataToPost);
        console.log(postUnapprove);

        if (postUnapprove[0].Results == "0") { 
          this.approveResultMessage = this.approveResultMessage + new Date().formatString('yyyy-MM-dd HH:mm:ss') + '| ' + val['Document Type'] + ' ' + val['Document No'].trim() + ' cancelled.\n';
        } else {
          this.approveResultMessage = this.approveResultMessage + new Date().formatString('yyyy-MM-dd HH:mm:ss') + '| ' + val['Document Type'] + ' ' + val['Document No'].trim() + ' cancel failed. ' + postUnapprove[0].ErrMsg + '.\n';
        }
        this.refreshClicked();
      } catch (e) {
        console.log(e);
      }
    },

    bucketChecked: function(index) {
      let bucketChecked = this.buckets[index]['bucketChecked'];
      let docs = this.buckets[index]['Documents'];
      if (docs.length > 0) {
        let isChecked = docs.filter(d => d['show'] && (d['APStatus'] != 'R' && d['Assigned'] != '0'));
        isChecked.forEach(d => d['checked'] = bucketChecked);
      }
      this.documentCheckedCount();
      this.removeUncheckedData();
    },

    documentChecked: function(index) {
      let docs = this.buckets[index]['Documents'].filter(f => f['show']);
      let checked = docs.filter(d => d['checked']);
      console.log(docs);
      console.log(checked);
      this.buckets[index]['bucketChecked'] = docs.length == checked.length;
      console.log(docs.length);
      console.log(checked.length);
      console.log(this.buckets[index]['bucketChecked']);
      this.documentCheckedCount();
      this.removeUncheckedData();
    },

    removeUncheckedData: function() {
      this.buckets.forEach(a => {
        let unchecked = a['Documents'].filter(b => b['checked'] == false) ;
        unchecked.forEach(a => {
          a['approveremarks'] = '';
          a['documentremarks'] = '',
          a['documents'] = []
        });
      })
    },

    documentCheckedCount: function() { 
      this.checkedCount = 0;
      this.selectedCheckedDocument = [];
      this.buckets.forEach(a => {
        let filtered = a['Documents'].filter(b => b['checked'] == true);
        this.checkedCount = this.checkedCount + filtered.length;
        this.selectedCheckedDocument = this.selectedCheckedDocument.concat(filtered);
      });
    },
    
    infoClicked: function(e, item) {
      let parent = e.target.parentNode.parentNode.parentNode; //get the icon parent objecct
      let parentSize = parent.getBoundingClientRect(); //get the measurement of the object
      
      let infoLeft = parentSize.left - (this.showInfoPopupDetailsMore ? 610 : 450); //405
      let infoTop = parentSize.top; 
      let infoHeight = parentSize.height + 150; //+ 150 to make it bigger 
      
      if (infoLeft <= 45) {
        infoLeft = parentSize.right + 5;
      }
      if (parentSize.top > window.innerHeight * 0.60) { //if more than 60% then reduce the top so the height wont exceed the page
        infoTop = infoTop - 150;
      }

      this.$set(this.infoPopupStyle, 'left', `${infoLeft}px`);
      this.$set(this.infoPopupStyle, 'top', `${infoTop}px`);
      this.$set(this.infoPopupStyle, 'height', `${infoHeight}px`);
      // this.$set(this.infoPopupStyle, 'width', this.showInfoPopupDetailsMore ? '500px' : '400px');

      this.infoPopupDetails = item;
      this.showInfoPopup = true;
    },

    infoMoreClicked: function(e) {
      this.showInfoPopupDetailsMore = !this.showInfoPopupDetailsMore;
      // console.log(e);
      // console.log(e.target.parentNode.parentNode.getBoundingClientRect().left);
      let parent = e.target.parentNode.parentNode;
      let parentSize = parent.getBoundingClientRect();
      // console.log(this.showInfoPopupDetailsMore);
      // console.log(parentSize.left);
      let infoLeft = parentSize.left - (this.showInfoPopupDetailsMore ? 160 : -160);
      // console.log(infoLeft);
      if (infoLeft <= 45) {
        infoLeft = parentSize.right + 5;
        infoLeft = infoLeft + 160;
      }
      // console.log(infoLeft);
      this.$set(this.infoPopupStyle, 'left', `${infoLeft}px`);
    },

    filterData: function() {
      this.buckets.forEach((b, bi) => { 
        if (bi == 3) {
          return;
        }
        
        b['Documents'].forEach(t => this.$set(t, 'show', false));
        let filterStatus = this.selectedStatus ? this.selectedStatus['Status'].trim() == 'All' ? '' : this.selectedStatus['Status'].trim() : '';
        let filterIssued = this.selectedIssuedTo ? this.selectedIssuedTo['Issued To Code'].trim() : '';
        let filterPaymentType = this.selectedPaymentType ? this.selectedPaymentType['Payment Type'].trim() : '';
        let chargesCode = this.selectedChargesCode.map(s => s['Charge Code']);
        console.log(chargesCode);
        console.log(filterStatus);
        let toShow = b['Documents'].filter(d => {
          try {
            let result = true;
            if (filterStatus) {
              if (filterStatus == 'Rejected') {
                result = result && d['APStatus'].includes('R');
                console.log(result);
              } else if (filterStatus == 'Pending') {
                result = result && !d['APStatus'].includes('R');
                console.log(result);
              }
            }

            if (filterIssued) {
              result = result && d['Issued To Code'].includes(filterIssued);
            }

            if (filterPaymentType) {
              result = result && d['PaymentType'].trim().includes(filterPaymentType);
            }

            if (this.createdby) {
              result = result && d['User ID'].trim().toLowerCase().includes(this.createdby.trim().toLowerCase());
            }
            
            if (chargesCode.length > 0) {
              if (d['AdditionalDetails']) {
                d['AdditionalDetails'].forEach(e => {
                  result = result && (e['ChargesCode'] ? chargesCode.includes(e['ChargesCode'].trim()) : false);
                })
              }
            }

            if (this.amount) {
              if (this.amountOperationIndex == 0) {
                result = result && parseFloat(d['Total Amount']) >= this.amount;
              } else if (this.amountOperationIndex == 1) {
                result = result && parseFloat(d['Total Amount']) <= this.amount;
              } else if (this.amountOperationIndex == 2) {
                result =result && parseFloat(d['Total Amount']) == this.amount;
              }
            }

            if (result) {
              return d;
            } else {
              d['checked'] = false;
            }
          } catch (error) {
            console.log(error);
            console.log(d);
          }
        });

        b['FilteredCount'] = toShow.length;
        console.log(b['FilteredCount']);
        console.log(b);

        let checked = b['Documents'].filter(d => d['checked']);
        b['bucketChecked'] = b.length == checked.length;
        this.documentCheckedCount();
        toShow.forEach(t => this.$set(t, 'show', true));
      });
    },

    approveButtonClick: function() {
      if (this.checkedCount > 0) {
        this.popupEntryRequest = 'Approve';
        this.showApprovePopup = true;
      } else {
        this.approveResultMessage = this.approveResultMessage + 'Please select a document before making an approval.\n';
        // this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight + 100;
        // this.$nextTick(() => this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight + 100);
        // this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight + 100;
      }
    },

    rejectButtonClick: function() {
      if (this.checkedCount > 0) {
        this.popupEntryRequest = 'Reject';
        this.showApprovePopup = true;
      } else {
        this.approveResultMessage = this.approveResultMessage + 'Please select a document before making a rejection.\n';
      }
    },

    documentSelected: async function(att, index) {
      var attList = [];
      for (var i = 0; i < att.length; i++) {
        var base64 = await this.$convertFile.toBase64(att[i]);
        attList.push( {
          'docatt': att[i].name, 
          'filetype': att[i].type,
          'attfile': base64,
          'docaction':'N'
        });
        this.selectedCheckedDocument[index]['documents'] = attList;
      }

    },

    approveClick: async function() {
      let tempeMessages = [];
      if (this.popupEntryRequest == 'Reject') {
        console.log('herere2t');
        this.selectedCheckedDocument.forEach(a => {
          if (!a['approveremarks']) {
            console.log('hereret1');
            tempeMessages.push(`${a['Document No']} reject remarks cannot be empty.`);
            this.Emessages.push(`${a['Document No']} reject remarks cannot be empty.`);
            console.log('hereret3');
          }
        });
        console.log(tempeMessages);
      }

      if (tempeMessages.length == 0) {
        this.quickApprovedClicked();
        this.showApprovePopup = false;
        this.popupEntryRequest = '';
      }
    },

    cancelClick: function() {
    },

    showAttachment: async function(e, item) {
      this.loading = true;
      this.loadText = "Getting Attachments";
      this.attachmentList = await this.$apiCallV2('/DocumentApproval/GetJobDocuments?jobno='+item['Document No']);
      var tempIssuedTo = item['Issued To'];
      var tempBLNo = item['BL No'] ? item['BL No'] : '';
      var tempCurrency = item['Currency'];
      var tempTotalAmount = item['Total Amount'];
      this.attAdditionalDetails = item['AdditionalDetails'];
      this.attachmentList.forEach(a => {
        a['Issued To'] = tempIssuedTo;
        a['BL No'] = tempBLNo;
        a['Currency'] = tempCurrency;
        a['Total Amount'] = tempTotalAmount;
      });
      // this.attachmentlist['Issued To1'] = item[0]['Issued To'];
      // this.attachmentList['BL No1'] = item[0]['BL No'];
      if (this.attachmentList.length < 1) {
        //no attachment records... do right side pop up notification to show message.
      } else {
        this.convertImage();//(this.attachmentList);
        this.attToView = this.attachmentList[0];
      }

      this.loading = false;
      this.showAttachmentPopup = true;
    },

    navAtt: function(clicked) {
      var currentindex = this.attachmentList.indexOf(this.attToView);
      var length = this.attachmentList.length - 1;
      
      if (clicked == 'prev') {
        if (currentindex == 0) 
          currentindex = length;
        else
          currentindex = currentindex - 1;
      } else {
        if (currentindex == length) 
          currentindex = 0;
        else
          currentindex = currentindex + 1;
      }

      this.attToView = this.attachmentList[currentindex];
    },

    closeshowAttachmentPopup: function() {
      this.showAttachmentPopup = false;
      
    },

    convertImage: function() {
    //loop to get and convert all attImg
    try {

      this.attachmentList.forEach(j => {
        var type = '';
        if (j['AttImageType'] == null) {
          j['AttImageType'] = 'n/a';
        } else {
          j['AttImageType'] = j['AttImageType'].trim();
          type = j['AttImageType'];
        }
        
        //if empty
        if (j['AttImage'] == null || j['AttImage'].length == 0) {
          j['AttImage'] ="https://i.ibb.co/kyZfpjx/no-image.png";
          //if value = pdf file
        } else if (type === ".pdf" ) {
          j['AttImage'] = 'data:application/pdf;base64,' + j['AttImage'];
        } else if (type === ".xlsx" ) {
          j['AttImage'] = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + j['AttImage'].slice(0, -1);
        } else if (type === ".ogg" ) {
          j['AttImage'] = 'data:audio/ogg;base64,' + j['AttImage'];
        } else if (type === ".pptx" ) {
          j['AttImage'] = 'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,' + j['AttImage'].substring(0,j['AttImage'].length - 4);
        } else if (type === ".docx" ) {
          j['AttImage'] = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + j['AttImage'];
        } else if (type === ".msg") {
          j['AttImage'] = 'data:application/vnd.msoutlook;base64,' + j['AttImage'];
        } else if (type === ".jpeg" || type === '.jpg' || type === 'image/Jpeg' || type === 'image/png' || type === '.jpeg' || type === 'image/jpeg' || type === '.png' || type === '.gif') {
          j['AttImage'] = 'data:image/png;base64,' + j['AttImage'];
        } else {
          j['AttImage'] = 'data:application/octet-stream;base64,' + j['AttImage'];
        }
      });
      } catch(e) {
        console.log(e);
      }
    },

    windowResize: function() {
      var width = window.innerWidth;
    },

    downloadpop: function() {
    var doc=this.attToView['AttImage'];
    var status = this.attToView['Status'].trim();

    var type = this.attToView['AttImageType'].trim();

    var link = document.createElement('a');
    link.href = doc;
    link.download = this.attToView['Job No'].trim()+ '_' + status + type;
    link.click();
    },

    generateButtonClick: function() {
      this.bankcode = [];
      this.fileno = [];
      this.fileNoTableData = [];
      this.selectedBankCode = null;
      this.selectedFileNo = null;
      console.log('here1');
      this.showGenerateListPopup = !this.showGenerateListPopup;
      this.loading = true;
      this.loadText = "Getting Data";
      console.log('here2');
      this.getGenerateListData();
      console.log('here3');
      this.loading = false;
    },

    generateListButtonClick: async function(e) {
      // this.bankcode = [];
      // this.fileno = [];
      // this.fileNoTableData = [];
      // this.selectedBankCode = null;
      // this.selectedFileNo = null;
      console.log(e);
      if (e == "Cancel") {
        console.log('can');
        this.showGenerateListPopup = false;
      } else if (e == "Generate New List") {
        console.log('genquestion');
        if (!this.selectedBankCode) { 
          console.log('quest2')
          // this.$alert.showAlert('Invalid Date Field', 'Please select a valid Date Field from the dropdown list', 'error');
          this.$showAlert('error', 'No Bank Selected', 'Bank cannot be empty. Please select a bank from the Bank List.');
        } else {
          console.log('new file');
          // this.showGenerateListPopupLoading = true;
          // this.showGenerateListPopupLoadingText = 'Generating List';
          this.$fullscreenLoading('Generating List');
          await this.getGenerateListTableData('NEWFILENO');
          // this.showGenerateListPopupLoading = false;
          // this.showGenerateListPopupLoadingText = '';
          this.$fullscreenLoading();
        }
      } else if (e == 'Print List') {
        console.log('print can');
        if (!this.selectedFileNo) {
          console.log('print cannot');
          this.$showAlert('error','No File Selected', 'File cannot be empty. Please select a file before printing.');
        } else {
          console.log('can print');
          console.log(this.fileNoTableData);
          var data = {
            fileno: this.selectedFileNo['FileNo'],
            dateprint: new Date().formatString('yyyy-MM-dd HH:mm'),
            printby: this.userid,
            document: this.fileNoTableData
          };
          console.log(data);
          this.designerV2Data = data;
          this.showDesignerV2 = true;
        }
      }
    },

    getGenerateListData: async function() {
      this.bankCode = await this.$apiCallV2('/DocumentApproval/getListMaster?masterfile=bank&module=da');
      this.bankCode.forEach(b => {
        b['BankCodeBankName'] = `${b['BankCode']}-${b['BankName']}`;
      });
      console.log(this.bankCode);
    },

    getGenerateListTableData: async function(action) {
      console.log('hereqq');
      console.log(action);
      let tempfileno = '';
      let tempaction = '';
      if (action.trim() == 'GETALLFILENO') {
        tempfileno = '';
        tempaction = '';
        let generateListJSON = {
          "date": "",
          "bankcode": this.selectedBankCode["BankCode"],
          "action": tempaction,
          "fileno": tempfileno
        }
        this.fileno = [];
        this.fileno = await this.$apiCallV2('/DocumentApproval/DocApprovalGenerateList', generateListJSON);

      } else if (action.trim() == 'GETFILENODATA') {
        tempfileno = this.selectedFileNo['FileNo'];
        tempaction = '';
        let generateListJSON = {
          "date": "",
          "bankcode": this.selectedBankCode["BankCode"],
          "action": tempaction,
          "fileno": tempfileno
        }
        this.fileNoTableData = await this.$apiCallV2('/DocumentApproval/DocApprovalGenerateList', generateListJSON);
      } else if (action.trim() == 'NEWFILENO') {
        tempfileno = '';
        tempaction = 'N';
        let generateListJSON = {
          "date": "",
          "bankcode": this.selectedBankCode["BankCode"],
          "action": tempaction,
          "fileno": tempfileno
        }
        this.fileno = await this.$apiCallV2('/DocumentApproval/DocApprovalGenerateList', generateListJSON);
        let Results = this.fileno[0]['Results'];
        let ErrMsg = this.fileno[0]['ErrMsg'];
        let FileNo = this.fileno[0]['FileNo'];

        if (Results == 1) {
          await this.getGenerateListTableData('GETALLFILENO');
          this.selectedFileNo = null;
          this.$showAlert('info', 'Info', ErrMsg.trim());
        } else if (Results == 0) {
          this.newFileNo = FileNo.trim();
          this.fileno = [];
          console.log(this.newFileNo);
          await this.getGenerateListTableData('GETALLFILENO');
          console.log(this.fileno);
          let tempselectedfileno = this.fileno.find(b => b['FileNo'] == this.newFileNo);
          console.log(tempselectedfileno);
          var newIndex = this.fileno.indexOf(tempselectedfileno);
          console.log(newIndex);
          this.selectedFileNo = this.fileno[newIndex];
          console.log(this.selectedFileNo);
          this.newFileNo = null;
        }
      }
    },

    backendError: async function() {
      // let data = await this.$apiCallV2('/UserManagement/GetListMasterError');
      // this.$store.state['errorDetails'] = { name: 'Azizi' };

      // this.$bus.$emit('pageError', 'hey');
    },

    apiError: async function() {
      // let data = await this.$apiCallV2('/UserManagement/GetListMasterError'); //qyvoon temp remove
    },

    selectVisibleDocOnly: function(e) { // e is the index of the bucket
      let selectAllVisible = this.bucketsSelectVisibleTooltip[e]['text'].split(' ')[0] == 'Select';
      let { docIndexes, bucketIndex } = this.getVisibleDocs(e);

      docIndexes.forEach(i => {
        this.buckets[bucketIndex[0]]['Documents'][i]['checked'] = selectAllVisible;
      });
      this.buckets[bucketIndex[0]]['bucketChecked'] = this.buckets[bucketIndex[0]]['Documents'].filter(f => f['show']).length == this.buckets[bucketIndex[0]]['Documents'].filter(f => f['checked']).length;
      this.documentCheckedCount();

      this.$set(this.bucketsSelectVisibleTooltip[e], 'text', `${selectAllVisible ? 'Unselect' : 'Select'} Visible Document(s) Only`);
    },
    getVisibleDocs: function(e) {
      let bucket = document.getElementsByClassName('bucket')[e];
      let content = bucket.getElementsByClassName('content')[0];
      let contentRect = content.getBoundingClientRect();

      let top = contentRect.top - 5;
      let bottom = contentRect.bottom + 5;

      let allItems = Array.from(content.getElementsByClassName('content-item'));
      let visibleItems = allItems.filter(a => {
        let itemRect = a.getBoundingClientRect();
        let itemTop = itemRect.top;
        let itemBottom = itemRect.bottom;

        // return itemTop >= top && itemBottom <= bottom; // Only fully visible item is selected
        // return (itemTop >= top && itemTop <= bottom) || (itemBottom >= top && itemBottom <= bottom); // Item partially visible is selected
        return itemTop + 5 >= top && (itemTop + (itemRect.height / 2)) <= bottom; // Item partially visible is selected but the top must be visible
      });

      let docIndexes = visibleItems.map(v => Number(v.getAttribute('docIndex')));
      let bucketIndex = [...new Set(visibleItems.map(v => Number(v.getAttribute('bucketIndex'))))];

      return { 'docIndexes': docIndexes, 'bucketIndex': bucketIndex };
    },
    bucketScrolling: function(ind) {
      let { docIndexes, bucketIndex } = this.getVisibleDocs(ind);

      let checkCount = 0;
      docIndexes.forEach(i => {
        if (this.buckets[bucketIndex[0]]['Documents'][i]['checked']) {
          checkCount++;
        }
      });

      this.$set(this.bucketsSelectVisibleTooltip[bucketIndex], 'text', `${checkCount == docIndexes.length ? 'Unselect' : 'Select'} Visible Document(s) Only`);
    },

    windowResize: function() {
      this.narrowWindow = window.innerWidth < 900;
    }
  },
  async mounted() {
    this.selectedDocType = this.docType[0];
    this.selectedTop = this.topList[this.topList.length - 2]; //get the value 500 object
    this.selectedStatus = this.statusType[0];

    this.loading = true;
    this.loadText = 'Getting Details';

    var userDetails = await this.$apiCallV2(`/Login/GetDetails`);
    this.userid = userDetails.LoginUserId;

    // this.issuedTo = await this.$apiCallV2(`/DocumentApproval/GetIssuedTo?tablename=${this.selectedDocType['Code']}`);
    this.issuedTo = await this.$apiCallV2(`/DocumentApproval/GetIssuedTo?tablename=all&userid=${this.userid}`);
    this.paymentType = await this.$apiCallV2('/DocumentApproval/getListMaster?masterfile=paymenttype');
    this.chargesCode = await this.$apiCallV2('/DocumentApproval/getListMaster?masterfile=chargescode');
    // this.buckets = await this.$apiCallV2(`/DocumentApproval/getListMaster?masterfile=dashboard_documentapproval`);
    this.buckets = await this.$apiCallV2('/DocumentApproval/getListMaster?masterfile=dashboard_documentapproval');
    this.bucketsSelectVisibleTooltip = this.buckets.map((b, bi) => ({ bucket: `Bucket${bi}`, text: 'Select Visible Document(s) Only' }));

    this.loading = false;

    await this.callAPI();
    if (window.innerWidth < 900) {
      this.narrowWindow = true;
    }
    window.addEventListener('resize', this.windowResize);
  },
  watch: {
    selectedStatus: function(val) {
      this.filterData();
    },
    selectedIssuedTo: function(val) {
      // if (val) {
      //   this.filterData();
      // }
       this.filterData();
      // if (val) {
      //   this.buckets.forEach(b => {
      //     let issuedTo = val['Issued To Code'].trim();
      //     let toHide = b['Documents'].filter(d => !d['Issued To Code'].includes(issuedTo));
      //     toHide.forEach(t => this.$set(t, 'show', false));
      //   });
      // } else {
      //   this.buckets.forEach(b => {
      //     b['Documents'].forEach(d => this.$set(d, 'show', true));
      //   });
      // }
    },
    selectedPaymentType: function(val) {
      // if (val) {
      //   this.filterData();
      // }
       this.filterData();
      // if (val) {
      //   this.buckets.forEach(b => {
      //     b['Documents'].forEach(d => this.$set(d, 'show', true));
      //     let paymentType = val['Payment Type'].trim();
      //     let toHide = b['Documents'].filter(d => !d['PaymentType'].includes(paymentType));
      //     toHide.forEach(t => this.$set(t, 'show', false));
      //   });
      // } else {
      //   this.buckets.forEach(b => {
      //     b['Documents'].forEach(d => this.$set(d, 'show', true));
      //   });
      // }
    },
    createdby: function(val) {
      // if (val) {
      //   this.filterData();
      // }
       this.filterData();
      // if (val) {
      //   this.buckets.forEach(b => {
      //     let toHide = b['Documents'].filter(d => !d['User ID'].includes(this.createdby));
      //     toHide.forEach(t => this.$set(t, 'show', false));
      //   });
      // } else {
      //   this.buckets.forEach(b => {
      //     b['Documents'].forEach(d => this.$set(d, 'show', true));
      //   });
      // }
    },
    amount: function(val) {
      // if (val) {
      //   this.filterData();
      // }
       this.filterData();
      // if (val) {
      //   if (this.amountOperationIndex == 0) {
      //     this.buckets.forEach(b => {
      //       let toHide = b['Documents'].filter(d => d['Total Amount'] >= this.amount);
      //       toHide.forEach(t => this.$set(t, 'show', false));
      //     })
      //   }
      // } else {
      //   this.buckets.forEach()
      // }
    },
    selectedChargesCode: function(val) {
      // if (val) {
      //   if (val.length > 0) {
      //     this.filterData();
      //   }
      // }
      this.filterData();
    },
    approveResultMessage: function(val) {
      this.$nextTick(() => this.$refs.msgbox.scrollTop = this.$refs.msgbox.scrollHeight + 100);
    },
    showApprovePopup: function(val) {
      this.Emessages = [];
      this.successMessages = [];
    },
    selectedBankCode: async function(val) {
      console.log(val);
      if (val) {
        console.log('herebank');
        this.selectedFileNo = null;
        this.generateListTableTitle = '';
        this.fileNoTableData = [];
        this.$fullscreenLoading(`Getting ${val['BankCode']} files`)
        await this.getGenerateListTableData('GETALLFILENO');
        this.$fullscreenLoading();
        console.log(this.fileno);
      }
    },
    selectedFileNo: function(val) {
      console.log(val);
      this.fileNoTableData = [];
      this.generateListTableTitle = '';
      // console.log(this.generateListTableTitle);
      if (val) {
        console.log('herefile');
        this.getGenerateListTableData('GETFILENODATA');
        this.generateListTableTitle = val["FileNo"];
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResize);
  }
  // created() {
  //   window.addEventListener('resize', this.windowResize);
  // }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.doc-page-main {
  font-size: 12px;
  padding: 10px 45px;
  display: flex;

  > .left-container {
    border-radius: 5px;
    max-width: 250px;
    min-width: 250px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    transition: 0.3s;
    overflow: hidden;

    > .arrow-button {
      width: 100%;
      padding: 7px 4px 50px 0px;
      display: flex;
      justify-content: flex-end;

      > img {
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transform: scale(1);
        transition: 0.3s;
        cursor: pointer;
      }
    }

    > .refresh-icon, .quick-approve-icon {
      padding-bottom: 5px;
      padding-left: 5px;
    }

    > .left-container-content {
      display: flex;
      background-color: white;
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 5px;

      > button {
        width: 90%;
        margin: auto;
        margin-top: 5px;
        margin-bottom: 5px;
      }
  
      // > .refresh-button {
      //   width: 100%;
      //   margin-bottom: 5px;
      // }
  
      // > .reset-filter-button {
      //   width: 100%;
      //   margin-bottom: 5px;
      // }
  
      // > .quick-approve-button {
      //   width: 100%;
      //   margin-bottom: 5px;
      // }
  
      // > .approve-button, .reject-button, .generate-button {
      //   width: 100%;
      //   margin-bottom: 5px;
      // }
  
      > .amount-container {
        display: flex;
        align-items: center;
  
        > button {
          margin-right: 5px;
        }
      }
  
      > .charges-filter {
        width: 100%;
        height: 100px;
      }
    }
  }

  > .left-tab-close {
    max-width: 40px;
    min-width: 40px;
  }

  > .right-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    // max-width: calc(100% - 250px);
    height: 100%;
    transition: 0.3s;

    > .top-container {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      margin-bottom: 5px;
      display: flex;
      height: 135px;
      transition: 0.3s;

      > .filters-text {
        width: 40%;
        > .inline-text {
          display: flex;
          align-items: center;
  
          > div:nth-child(2) {
            margin-right: 5px;
          }
  
          > .caption {
            min-width: 105px;
          }
        }
      }

      > .message-box {
        flex-grow: 1;
        margin-right: 5px;
        background-color: rgba(255, 246, 121, 0.37);
        overflow: auto;
        height: 100%;
        padding-left: 5px;
        width: 60%;
        white-space: pre-wrap;
        overflow: auto;
      }

      > .arrow-button {
        // width: 10%;
        // padding: 7px 4px 50px 0px;
        display: flex;
        justify-content: flex-end;

        > img {
          height: 30px;
          width: 30px;
          padding: 2px;
          z-index: 1;
          transform: scale(1);
          transition: 0.3s;
          cursor: pointer;
        }
      }
    }

    > .right-filter-msg-close {
      height: 35px;
      display: flex;
      flex-direction: column;

      > .arrow-button {
        justify-content: flex-end;
      }
    }
  
    > .bottom-container {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      height: 100%;
      // max-height: calc(100% - 140px);
      display: flex;
      width: 100%;
      transition: 0.3s;
  
      > .bucket {
        height: 100%;
        width: 100%;
        margin-right: 5px;
        border: 1px solid black;
        display: flex;
        flex-direction: column;

        > .header {
          height: 100px;
          display: flex;
          flex-direction: column;
          padding: 10px;
          position: relative;

          > .bucketTotal {
            position: absolute;
            top: 1px;
            right: 5px;
          }

          > .title {
            height: 100%;
            width: 100%;
            text-align: center;
            font-size: 1.2em;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;

          }

          > .count {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid gray;
            padding-bottom: 5px;
          }

          > .tooltip-button {
            cursor: pointer;
            position: absolute;
            bottom: 15px;
            right: 15px;
            z-index: 9;
          }
        }

        > .content {
          height: 100%;
          overflow: auto;
          padding: 5px;

          
          > .content-item {
            border: 1px solid gray;
            padding: 5px;
            margin-bottom: 5px;

            > .long-text {
              width: 100%;
              overflow:hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            > .content-row {
              width: 100%;
              display: flex;
              align-items: center;

              > .doc-no {
                font-weight: bold;
                font-size: 1.1em;
              }

              > .pay-button {
                background-color: rgb(0, 176, 240);
                padding: 2px 20px;
              }

              > .amount {
                font-weight: bold;
              }

              > .icon-button > img {
                height: 20px;
                margin-left: 3px;
                cursor: pointer;
              }

              > :nth-child(1) {
                width: 100%;
              }

              > :nth-child(2) {
                width: fit-content;
                white-space: nowrap;
              }
            }

            > :first-child {
              margin-bottom: 10px;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
  
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  > .info-popup {
    position: fixed;
    z-index: 999;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 0 8px gray;
    // width: 500px;
    height: 200px;
    overflow-y: scroll;

    > .info-header {
      display: flex;
      align-items: center;
      padding: 3px 5px;
      // border-bottom: 1px solid gray;

      > :first-child {
        width: 100%;
        font-weight: bold;
      }

      > :nth-child(2) {
        min-width: 45px;
        max-width: 45px;
        cursor: pointer;
      }

      > :last-child {
        cursor: pointer;
      }
    }

    > .info-content {
      overflow: auto;

      // > .info-content-header {
      //   display: flex;
      // }

      > .info-content-table {
        border-collapse: collapse;
        width: 100%;
        // border: 1px solid black;
        // border-bottom: 1px solid gray;
        table-layout: auto;

        > tr > th, td {
          padding: 3px;
          border: 1px solid gray;

          &:nth-child(1) { min-width: 25px; max-width: 30px; }
          &:nth-child(2) { min-width: 215px; max-width: 215px; }
          &:nth-child(3) { min-width: 30px; max-width: 30px; }
          &:nth-child(4) { min-width: 80px; max-width: 80px; text-align: right; } 
          &:nth-child(5) { min-width: 80px; max-width: 80px; text-align: right; }
          &:nth-child(6) { min-width: 80px; max-width: 80px; text-align: right; }
          &:last-child { min-width: 90px; max-width: 90px; text-align: left; }
        }

        .tableTooltip .tableTooltipText {
          visibility: hidden;
          position: absolute;
          z-index: 10;
          background-color: black;
          color: #fff;
          text-align: center;
          border-radius: 5px;
          padding: 2px;
        }

        .tableTooltip:hover .tableTooltipText {
          visibility: visible;
        }
        // th, td {
        //   border: 1px solid gray;
        //   // padding: 5px;
        // }
      }

      // > .info-content-row, .info-content-header {
      //   display: flex;
      //   align-items: center;
      //   padding: 1px 5px;
      //   border-bottom: 1px solid rgba(150,150,150,0.3);
      //   font-size: 0.95em;

      //   > :not(:first-child) {
      //     border-left: 1px solid black;
      //   }

      //   > * {
      //     padding: 3px;
      //   }

      //   > :first-child { min-width: 25px; max-width: 30px; }
      //   > :nth-child(2) { min-width: 215px; max-width: 215px; }
      //   > :nth-child(3) { min-width: 25px; max-width: 30px; }
      //   > :nth-child(4) { min-width: 45px; max-width: 45px; } 
      //   > :nth-child(5) { min-width: 45px; max-width: 45px; }
      //   > :nth-child(6) { min-width: 45px; max-width: 45px; }
      //   > :last-child { min-width: 90px; max-width: 90px; margin-left: 5px; }
      // }
    }
  }

.attchWin-main {
  z-index: 1000;

  > .attchWin-display {
    width: 90%;

    > .left {

      > .attchWin-attachment {
        width: 90%;
        height: 95%;
        display: flex;
      }
    }
  }
}

.attachmentAddInfoMain {
  width: auto;
  height: 160px;
  // padding: 5px;
  overflow-y: scroll;
}

.addInfoRow {
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: solid 1px #0001;

  > div {
    padding: 0 4px;
  }
}

.generateList-main {
  height: 100%;
  text-align: left;

  > .generateList-filter {
    margin: 5px;
    height: 15%;
  }

  > .generateList-table {
    margin: 5px;
    height: 80%;
  }
}

  > .designerv2-popup {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    padding: 10px 45px;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;

    > :first-child {
      background-color: white;
    }
  }
}

@media only screen and (max-width: 900px) {
  .doc-page-main {
    flex-direction: column;

    > .left-container {
      height: 100%;
      // max-height: 300px;
      width: 100%;
      max-width: 100%;
      // max-height: 40px;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      margin-bottom: 5px;

      > .arrow-button {
        width: 30px;
        padding: 0;

        > img {
          margin-top: 2.5px;
          transform: rotate(90deg);
        }
      }

      > .left-container-content {
        width: 100%;
        // height: 190px;
        padding-top: 5px;
        display: block;
        // align-items: flex-start;
        flex-direction: column;
        overflow: auto;

        //hide scrollbar
        // > ::-webkit-scrollbar {
        //   display: none;
        // }

        button {
          width: 100%;
        }
      }
    }

    > .left-tab-close {
      // max-width: 40px;
      max-width: 100%;
    }

    > .left-tab-close-up-down {
      // overflow: hidden;
      max-height: 40px;
      min-height: 40px;
    }

    > .right-container {
      height: 100%;

      > .top-container {
        display: none;
      }

      // > .bottom-container {
        
      // }
    }
  }
}
</style>